import 'uni-pages';import 'uni-h5';import Vue from 'vue'
import App from './App'
import './uni.promisify.adaptor'
import api from './api/index'
import dayjs from 'dayjs'
import Vuex from 'vuex'
import store from '@/store'
import VueCoreVideoPlayer from 'vue-core-video-player'

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(VueCoreVideoPlayer)

// ios调试工具
import VConsole from 'vconsole'
let enableVConsole = process.env.VUE_APP_QW_VCONSOLE || window.location.href.includes('debug=true') || window.location.href.includes('debug=1')
if (enableVConsole) {
  new VConsole()
}
// 全局注册组件
import PublicLogo from '@/components/publicLogo'
Vue.component('PublicLogo', PublicLogo)

App.mpType = 'app'
Vue.prototype.$api = api
Vue.prototype.$dayjs = dayjs
Vue.prototype.$store = store
const app = new Vue({
  store,
  ...App
})
app.$mount()